// p-retry validates its options with Object.hasOwn (ES2022) on every call
// site inside braintreeProvider; this polyfill must load before those async
// handlers can run so pre-2022 browsers don't crash checkout (BKO-5562).
import 'core-js/stable/object/has-own';

import React from 'react';
import { createRoot } from 'react-dom/client';

import Routes from '@/routes';
import { ELEMENTS } from '@/constants';
import { usePageSetup } from '@/pageSetup';
import { VariationProvider } from '@/providers/variationProvider/VariationProvider';
import { initializeDatadogRum } from '@/utils/datadogRum';
import { StoreProvider } from '@/providers/StoreProvider';
import initialState from '@/initialStateV2';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';

import '@/scss/index.scss';

// Initialize Datadog RUM before React renders
initializeDatadogRum();

const App = () => {
  usePageSetup();

  return (
    <VariationProvider>
      <StoreProvider initialState={initialState}>
        <Routes />
      </StoreProvider>
    </VariationProvider>
  );
};

const container = document.getElementById(ELEMENTS.root);
if (!container) {
  throw new Error(`Root element with ID '${ELEMENTS.root}' not found.`);
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

if (import.meta.hot) {
  import.meta.hot.accept();
}
